import * as React from "react";
const SvgMediumRisk = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 8, fill: "#424242" }), /* @__PURE__ */ React.createElement("circle", { cx: 9, cy: 9, r: 3, fill: "#FABA2A" }));
export default SvgMediumRisk;
